export default __webpack_public_path__ + "static/media/edit.34d1469c.svg";